const services = [
  {
    icon: 'ri-flashlight-line',
    title: '電気工事',
    category: '電気設備',
    description:
      '幹線工事・受変電設備・動力設備・照明設備・弱電設備の設計・施工を行います。第一種電気工事士が在籍し、高圧から低圧まで対応可能です。',
    tags: ['受変電設備', '動力設備', '照明設備'],
    imageUrl:
      'https://readdy.ai/api/search-image?query=professional%20licensed%20electrician%20installing%20electrical%20distribution%20panel%20switchboard%20in%20commercial%20building%20interior%2C%20safety%20equipment%20worn%2C%20technical%20precision%20work%2C%20industrial%20electrical%20installation%20Japan%2C%20bright%20clean%20workspace&width=400&height=240&seq=biz001&orientation=landscape',
  },
  {
    icon: 'ri-water-flash-line',
    title: '管工事',
    category: '給排水・空調',
    description:
      '給水・排水・衛生設備の配管工事および空調設備の設置工事を担当します。官公庁・商業施設・集合住宅等の実績を多数保有しています。',
    tags: ['給排水設備', '衛生設備', '空調配管'],
    imageUrl:
      'https://readdy.ai/api/search-image?query=professional%20plumber%20installing%20industrial%20water%20supply%20pipe%20system%20in%20commercial%20building%2C%20technical%20piping%20work%2C%20organized%20clean%20mechanical%20room%2C%20safety%20gear%2C%20professional%20plumbing%20installation%20Japan&width=400&height=240&seq=biz002&orientation=landscape',
  },
  {
    icon: 'ri-road-map-line',
    title: '土木工事',
    category: '外構・土木',
    description:
      '道路工事・舗装工事・外構工事・擁壁工事を承ります。重機オペレーターが在籍し、掘削から整地まで一貫施工が可能です。',
    tags: ['舗装工事', '外構・擁壁', '掘削・整地'],
    imageUrl:
      'https://readdy.ai/api/search-image?query=professional%20civil%20engineering%20road%20construction%20paving%20work%20Japan%2C%20heavy%20machinery%20excavator%20operating%20at%20worksite%2C%20safety%20helmets%20worn%20by%20workers%2C%20organized%20infrastructure%20project%2C%20daytime%20outdoor%20professional%20setting&width=400&height=240&seq=biz003&orientation=landscape',
  },
  {
    icon: 'ri-home-gear-line',
    title: '内装工事',
    category: '内装・改修',
    description:
      '店舗・オフィス・倉庫の内装仕上げ工事および改修工事を行います。LGS・ボード・塗装・床工事まで、内装全般に対応します。',
    tags: ['LGS・ボード', '塗装・床工事', '店舗改修'],
    imageUrl:
      'https://readdy.ai/api/search-image?query=professional%20interior%20construction%20workers%20installing%20drywall%20gypsum%20board%20partition%20in%20commercial%20office%20space%2C%20precise%20interior%20finishing%20work%2C%20clean%20organized%20worksite%20Japan%2C%20modern%20renovation%20project&width=400&height=240&seq=biz004&orientation=landscape',
  },
  {
    icon: 'ri-tools-line',
    title: '保守・点検',
    category: '維持管理',
    description:
      '施工後の定期点検・保守メンテナンスに対応します。緊急トラブル時の迅速な駆けつけ対応も実施しており、長期的な設備維持をサポートします。',
    tags: ['定期点検', '緊急対応', 'トラブル対応'],
    imageUrl:
      'https://readdy.ai/api/search-image?query=facility%20maintenance%20technician%20performing%20systematic%20equipment%20inspection%20in%20commercial%20building%20mechanical%20room%2C%20professional%20service%20uniform%2C%20organized%20maintenance%20work%20Japan%2C%20technical%20inspection%20checklist&width=400&height=240&seq=biz005&orientation=landscape',
  },
  {
    icon: 'ri-building-line',
    title: '総合工事調整',
    category: '複合施工',
    description:
      '複数工種が絡む現場での工程管理・調整業務を担当します。自社施工比率を高めることで、協力業者への依存を最小化し、品質と工期を管理します。',
    tags: ['工程管理', '複合施工', '品質管理'],
    imageUrl:
      'https://readdy.ai/api/search-image?query=construction%20project%20manager%20reviewing%20building%20plans%20blueprints%20at%20organized%20office%20desk%2C%20professional%20construction%20management%20meeting%20Japan%2C%20multiple%20workers%20coordinating%20building%20project%2C%20clean%20modern%20office%20setting&width=400&height=240&seq=biz006&orientation=landscape',
  },
];

const BusinessSection = () => {
  return (
    <section id="business" className="w-full py-16 sm:py-20" style={{ backgroundColor: '#F5F7FA' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* セクションタイトル */}
        <div className="mb-12 text-center">
          <p className="text-xs font-semibold tracking-widest mb-2" style={{ color: '#2C5AA0', letterSpacing: '0.15em' }}>
            SERVICES
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold mb-3" style={{ color: '#1A1A1A' }}>
            事業内容・対応工種
          </h2>
          <div className="mx-auto" style={{ width: '48px', height: '2px', backgroundColor: '#2C5AA0' }}></div>
          <p className="mt-4 text-sm sm:text-base text-gray-500 max-w-xl mx-auto leading-relaxed">
            電気・管・土木・内装の各専門工種に自社施工体制で対応します。
            複合工種の現場でも一元管理が可能です。
          </p>
        </div>

        {/* カードグリッド */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service) => (
            <article
              key={service.title}
              className="bg-white rounded-lg overflow-hidden border border-gray-200 transition-all duration-200 hover:border-gray-300"
            >
              {/* カード画像 */}
              <div className="w-full overflow-hidden" style={{ height: '180px' }}>
                <img
                  src={service.imageUrl}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* カードコンテンツ */}
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <div
                    className="w-8 h-8 flex items-center justify-center rounded flex-shrink-0"
                    style={{ backgroundColor: '#EEF2FA' }}
                  >
                    <i className={`${service.icon} text-base`} style={{ color: '#2C5AA0' }}></i>
                  </div>
                  <div>
                    <span className="text-xs font-medium" style={{ color: '#2C5AA0' }}>
                      {service.category}
                    </span>
                    <h3 className="text-base font-bold leading-tight" style={{ color: '#1A1A1A' }}>
                      {service.title}
                    </h3>
                  </div>
                </div>

                <p className="text-sm leading-relaxed mb-3" style={{ color: '#555' }}>
                  {service.description}
                </p>

                {/* タグ */}
                <div className="flex flex-wrap gap-1.5">
                  {service.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-xs px-2 py-0.5 rounded-full border"
                      style={{ borderColor: '#D0DBF0', color: '#2C5AA0', backgroundColor: '#EEF2FA' }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessSection;
